import type { StoreSearchParams } from '@libs/common-types';

export const SELECTED_STORE_SEARCH_RADIUS_MILES = 30;

type StoreCoordinates = {
    Latitude?: number | null;
    Longitude?: number | null;
};

type ResolveStoreDrawerSearchArgs = {
    searchOptions: StoreSearchParams;
    store?: StoreCoordinates | null;
    selectedStoreId?: string;
    isSelectedStorePending: boolean;
};

export function getSelectedStoreSearch(store?: StoreCoordinates | null): StoreSearchParams | undefined {
    if (store?.Latitude == null || store.Longitude == null) {
        return undefined;
    }

    return {
        lat: store.Latitude,
        lng: store.Longitude,
        radius: SELECTED_STORE_SEARCH_RADIUS_MILES,
    };
}

export function resolveStoreDrawerSearch({
    searchOptions,
    store,
    selectedStoreId,
    isSelectedStorePending,
}: ResolveStoreDrawerSearchArgs): { search: StoreSearchParams; enabled: boolean } {
    const hasUserSearch = searchOptions.query != null || searchOptions.lat != null || searchOptions.lng != null;
    const awaitingSelectedStore = Boolean(selectedStoreId) && !hasUserSearch && isSelectedStorePending;

    return {
        search: hasUserSearch ? searchOptions : (getSelectedStoreSearch(store) ?? {}),
        enabled: !awaitingSelectedStore,
    };
}
